import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Sparkles, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SurveyReminderBanner = ({ onDismiss }) => {
 const navigate = useNavigate();

 return (
 <Card className="mb-6 bg-primary border-2 border-primary shadow-lg">
 <div className="p-4 flex items-center justify-between">
 <div className="flex items-center gap-4">
 <div className="bg-white text-primary p-3 rounded-full">
 <Sparkles className="w-6 h-6" />
 </div>
 <div>
 <h3 className="font-bold text-lg text-white">
 🎁 Get Your Personalized Experience!
 </h3>
 <p className="text-slate-100 text-sm">
 Complete our quick survey to unlock customized courses, products, and content recommendations tailored just for you. Takes only 2 minutes!
 </p>
 </div>
 </div>
 <div className="flex items-center gap-3">
 <Button
 onClick={() => navigate('/onboarding/survey')}
 className="bg-white text-primary hover:bg-slate-100 font-bold"
 data-testid="survey-reminder-take-survey"
 >
 Take Survey Now
 </Button>
 <Button
 variant="ghost"
 size="sm"
 onClick={onDismiss}
 className="text-slate-200 hover:text-white hover:bg-white/10"
 data-testid="survey-reminder-dismiss"
 >
 <X className="w-4 h-4" />
 </Button>
 </div>
 </div>
 </Card>
 );
};

export default SurveyReminderBanner;
